<template>
  <v-menu
    v-model="aberto"
    :close-on-content-click="false"
    :disabled="disabled"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        class="pulse-input pulse-datepicker"
        outlined
        dense
        readonly
        :hide-details="!temErro"
        :error-messages="errorMessages"
        :value="exibicao"
        :placeholder="placeholder"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
      >
        <template #append>
          <i class="pi pi-calendar pulse-input__icon" />
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      :value="value"
      no-title
      locale="pt-br"
      color="#6366f1"
      class="pulse-datepicker__panel"
      @input="selecionar"
    />
  </v-menu>
</template>

<script>
export default {
  name: "PulseDatePicker",
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "dd/mm/aaaa" },
    disabled: Boolean,
    errorMessages: { type: [String, Array], default: "" },
  },
  data: () => ({
    aberto: false,
  }),
  computed: {
    temErro() {
      return Array.isArray(this.errorMessages)
        ? this.errorMessages.length > 0
        : !!this.errorMessages;
    },
    exibicao() {
      if (!this.value) return "";
      const [ano, mes, dia] = String(this.value).substring(0, 10).split("-");
      return `${dia}/${mes}/${ano}`;
    },
  },
  methods: {
    selecionar(valor) {
      this.aberto = false;
      this.$emit("input", valor);
    },
  },
};
</script>
